import config from '@/config'

export default {
	id: 'SIMPLE_PAYWALL_4W_29_99_1W_4',
	providers: {
		stripe: config('stripe_cheap_and_short'),
		braintree: 'pro_short_cheap',
		paltaMap: {
			USD: 'simple_premium_4w_29_99_1w_4_usd',
			EUR: 'simple_premium_4w_29_99_1w_4_eur',
			GBP: 'simple_premium_4w_29_99_1w_4_gbp',
			AUD: 'simple_premium_4w_49_99_1w_6_aud',
			CAD: 'simple_premium_4w_49_99_1w_6_cad',
			DKK: 'simple_premium_comm_4w_259_24w_99_dkk',
			NOK: 'simple_premium_4w_399_1w_59_nok',
			SEK: 'simple_premium_4w_399_1w_59_sek',
			TRY: 'simple_premium_4w_999_1w_133_try',
			MXN: 'simple_premium_4w_499_1w_63_mxn',
			ARS: 'simple_premium_4w_39990_1w_6000_ars',
			COP: 'simple_premium_4w_119990_1w_17000_cop',
			CLP: 'simple_premium_4w_29990_1w_4000_clp',
		},
		primer: 'prd_dMbuZBHx49b7',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 1,
		intro_period_type: 'week',
		next_period_value: 4,
		next_period_type: 'week',
	},
	trial: {
		days: 7,
		priceMap: {
			USD: 4,
			EUR: 4,
			GBP: 4,
			AUD: 6,
			CAD: 6,
			DKK: 99,
			NOK: 49,
			SEK: 59,
			TRY: 133,
			MXN: 63,
			ARS: 6000,
			COP: 17000,
			CLP: 4000,
		},
		originalPriceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			NOK: 399,
			SEK: 399,
			TRY: 999,
			MXN: 499,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 1,
		priceMap: {
			USD: 29.99,
			EUR: 29.99,
			GBP: 29.99,
			AUD: 49.99,
			CAD: 49.99,
			DKK: 259,
			NOK: 399,
			SEK: 399,
			TRY: 999,
			MXN: 499,
			ARS: 39990,
			COP: 119990,
			CLP: 29990,
		},
	},
	options: ($t) => ({
		explicitTermsPeriodText: $t('pages.program.organic.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		explicitTermsIntervalText: $t('pages.program.organic.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
		billingSubtitlePeriodText: $t('pages.program.cheap_and_short.plans.7_days.into_period_text'), // 'first week'
		footerPeriodText: $t('pages.program.cheap_and_short.plans.7_days.period_text'), // '1-week'
		footerIntervalText: $t('pages.program.cheap_and_short.plans.7_days.sub_period_text'), // 'monthly'
	}),
}
